import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"17%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"17%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"17%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"24%"} })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Priority"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Weight"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Port"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Target"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Revalidate in")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "badge badge-secondary"
}
const _hoisted_5 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { getRecordType } from '@/common/recordTypes';
import { QueryResult, RecordInfo, SRV } from '@/model/Api';

type SrvRecordWithInfo = {
  record: SRV;
} & RecordInfo


export default /*#__PURE__*/_defineComponent({
  __name: 'SrvRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const recordType = getRecordType('SRV');



const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: SrvRecordWithInfo[] = props.records.response.answer.filter((item): item is SrvRecordWithInfo => item.record.recordType === recordType.upper);
  processed.sort((a, b) => a.record.priority - b.record.priority);

  return processed;
});

const minPriority = computed(() => Math.min(...processedRecords.value.map((r) => r.record.priority)));

return (_ctx: any,_cache: any) => {
  return (_unref(showRawOutput))
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (_unref(processedRecords).length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords), (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(record.record.priority), 1),
                  _createTextVNode(),
                  (record.record.priority === _unref(minPriority))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Primary"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(record.record.weight), 1),
                _createElementVNode("td", null, _toDisplayString(record.record.port), 1),
                _createElementVNode("td", null, [
                  _createVNode(DnsRecordsLink, {
                    domain: record.record.target,
                    class: "text-blue-600 hover:text-blue-800 hover:underline"
                  }, null, 8, ["domain"]),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.target,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, "No " + _toDisplayString(_unref(recordType).plural) + " found.", 1))
}
}

})